'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDirectionsSubway = function MdDirectionsSubway(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 18.4v-8.4h-8.4v8.4h8.4z m-2.5 10q1.1 0 1.8-0.8t0.7-1.7-0.7-1.8-1.8-0.7-1.8 0.7-0.7 1.8 0.7 1.7 1.8 0.8z m-9.1-10v-8.4h-8.4v8.4h8.4z m-5.9 10q1.1 0 1.8-0.8t0.7-1.7-0.7-1.8-1.8-0.7-1.8 0.7-0.7 1.8 0.7 1.7 1.8 0.8z m7.5-25q6.5 0 9.9 1.3t3.5 5.3v15.9q0 2.4-1.8 4.1t-4.1 1.6l2.5 2.5v0.9h-20v-0.9l2.5-2.5q-2.4 0-4.1-1.6t-1.8-4.1v-15.9q0-4 3.5-5.3t9.9-1.3z' })
        )
    );
};

exports.default = MdDirectionsSubway;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/directions-subway.js
// module id = 1437
// module chunks = 168707334958949